<mat-dialog-content  class="dialog-content fx-row">
  <p
    [textContent]="message"
    class="mat-body"
    fxFlex></p>
  <div  class="fx-row fx-jc-around fx-ai-center fx-gap-10"style="margin-bottom: 0px">
    <button
      (click)="confirm()"
      mat-flat-button
      color="warn"
      style="margin-left: 10px">
      {{ btnOkText }}
    </button>

    <button
      mat-flat-button
      color="warn"
      (click)="markAsRead()">
      <!-- {{ btnCancelText }} -->
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-dialog-content>
